import { styled } from '@mui/material';

const MintContainer = styled('div')(({ theme }) => ({
  width: '100%',
  maxWidth: '1200px',
  textAlign: 'center',
  padding: '54px 24px 75px 24px',
}));
export default MintContainer;
